import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Lock, Mail } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useBranding } from '../../context/BrandingContext';
import axios from 'axios';
import GoogleLoginButton from '../../components/GoogleLoginButton';

import { getBackendUrl } from '../../services/origin';
const API = getBackendUrl();

export default function AdminLogin() {
  const { adminLogin } = useAuth();
  const { business_name } = useBranding();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error('Compila tutti i campi'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/auth/admin/login`, { email, password });
      if (res.data.admin.role === 'superadmin') {
        toast.error('Usa il portale Superadmin per accedere');
        setLoading(false);
        return;
      }
      adminLogin(res.data.token, res.data.admin);
      toast.success(`Benvenuto, ${res.data.admin.name}!`);
      navigate('/admin');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Credenziali non valide');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-4">
      <div className="w-full max-w-sm animate-fade-in-up" data-testid="admin-login-page">
        <div className="text-center mb-8">
          <div
            className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg overflow-hidden bg-[#D44E20]"
          >
            <span className="text-white font-black text-2xl tracking-tight">L</span>
          </div>
          <h1 className="text-[#1A1A1A] font-bold text-2xl">Lazo</h1>
          <p className="text-[#64748B] text-sm mt-1">Dashboard Amministratore</p>
          {business_name && (
            <p className="text-[#94A3B8] text-xs mt-1.5 inline-flex items-center gap-1">
              <span className="w-1 h-1 rounded-full bg-[#94A3B8]" />
              {business_name}
            </p>
          )}
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-6 border border-slate-100 shadow-[0_2px_10px_rgba(0,0,0,0.04)] space-y-4">
          <div>
            <label className="block text-xs font-semibold text-[#1A1A1A] mb-1.5">Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-3 text-[#64748B]" />
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                data-testid="admin-email-input"
                placeholder="admin@example.it"
                className="w-full h-10 pl-10 pr-3 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#D44E20]/20 focus:border-[#D44E20] transition-all"
              />
            </div>
          </div>
          <div>
            <label className="block text-xs font-semibold text-[#1A1A1A] mb-1.5">Password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-3 text-[#64748B]" />
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                data-testid="admin-password-input"
                placeholder="La tua password"
                className="w-full h-10 pl-10 pr-3 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#D44E20]/20 focus:border-[#D44E20] transition-all"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full h-11 text-white font-bold text-sm rounded-xl disabled:opacity-50 active:scale-[0.98] transition-all bg-[#D44E20] hover:bg-[#B5421B]"
          >
            {loading ? 'Accesso...' : 'Accedi'}
          </button>

          <div className="relative py-1">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-slate-200" />
            </div>
            <div className="relative flex justify-center">
              <span className="bg-white px-2 text-[10px] font-semibold text-slate-400 uppercase tracking-wider">oppure</span>
            </div>
          </div>

          <GoogleLoginButton flow="login" testId="admin-google-login-btn" />
        </form>

        <button
          onClick={() => navigate('/staff/login')}
          data-testid="go-to-staff-btn"
          className="w-full mt-4 text-[#64748B] text-sm text-center hover:text-[#1A1A1A] transition-colors"
        >
          Accedi come operatore
        </button>
      </div>
    </div>
  );
}
